export default "__VITE_ASSET__BeLUlWyg__"